import { BrushIcon, PlusInSquareIcon } from "assets/icons";
import { If } from "components";
import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useBoolean } from "hooks";
import { t } from "i18next";
import { BoxShadowLayout, ContentLayout } from "layouts";
import {
  CreateOfferModal,
  OffersTable,
  SectionStyleModal,
  useOffersList
} from "modules/offers";
import { Button, Pagination, SearchInput } from "ui";

import styles from "./Offers.module.scss";

const Offers = () => {
  const {
    value: isOpenOfferModal,
    setTrue: onOpenOfferModal,
    setFalse: onCloseOfferModal
  } = useBoolean();

  const {
    value: isOpenSectionStyleModal,
    setTrue: onOpenSectionStyleModal,
    setFalse: onCloseSectionStyleModal
  } = useBoolean();

  const {
    offers,
    searchValue,
    setSearchValue,
    isLoading,
    sorting,
    page,
    setPage,
    totalItems,
    setSorting,
    setOffers
  } = useOffersList();

  return (
    <ContentLayout
      title={t("Special Offers")}
      action={
        <div className={styles.header}>
          <Button
            variant="default"
            onClick={onOpenSectionStyleModal}
            icon={<BrushIcon />}
          >
            {t("Section style")}
          </Button>
          <Button onClick={onOpenOfferModal} icon={<PlusInSquareIcon />}>
            {t("New Offer")}
          </Button>
        </div>
      }
    >
      <BoxShadowLayout className={styles.pageContent}>
        <SearchInput
          value={searchValue}
          onChange={setSearchValue}
          placeholder="Search..."
        />

        <OffersTable
          offersList={offers}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
          setOffers={setOffers}
          isDragDisabled={!!searchValue || sorting.length > 0}
        />

        <Pagination
          currentPage={page}
          onChange={setPage}
          perPage={GET_LIST_REQUEST_DEFAULT_LIMIT}
          totalItems={totalItems}
        />
      </BoxShadowLayout>

      <If condition={isOpenOfferModal}>
        <CreateOfferModal isOpen onClose={onCloseOfferModal} />
      </If>

      <If condition={isOpenSectionStyleModal}>
        <SectionStyleModal isOpen onClose={onCloseSectionStyleModal} />
      </If>
    </ContentLayout>
  );
};

export default Offers;
